import { render, staticRenderFns } from "./warningDetails.vue?vue&type=template&id=11b1f3a6&scoped=true&"
import script from "./warningDetails.vue?vue&type=script&lang=js&"
export * from "./warningDetails.vue?vue&type=script&lang=js&"
import style0 from "./warningDetails.vue?vue&type=style&index=0&id=11b1f3a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b1f3a6",
  null
  
)

export default component.exports